var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadApp1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 560,
    viewBox: "0 0 432 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1656_20388)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 560,
    fill: "#F4EFFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.997 424.611L160.502 471.356L171.884 478.552C171.884 478.552 184.089 472.365 184.594 471.861C185.099 471.356 188.949 468.347 188.949 468.347L191.285 424.63H161.997V424.611Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.52 439.042C190.52 439.042 184.595 441.472 182.595 446.256C180.595 451.041 184.856 449.77 185.436 449.77C186.015 449.77 186.52 450.013 185.511 451.658C184.501 453.284 183.585 454.387 183.997 456.144C184.408 457.901 187.454 458.499 189.529 457.078L190.52 439.042Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.596 463.226C162.596 463.226 169.455 456.441 172.053 456.441C174.651 456.441 171.978 460.871 172.053 461.955C172.128 463.039 175.641 460.273 177.081 461.282C178.501 462.292 177.828 465.375 176.408 467.637C174.987 469.899 173.81 472.235 173.81 472.235",
    fill: "#AE90E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.596 463.226C162.596 463.226 169.455 456.441 172.053 456.441C174.651 456.441 171.978 460.871 172.053 461.955C172.128 463.039 175.641 460.273 177.081 461.282C178.501 462.292 177.828 465.375 176.408 467.637C174.987 469.899 173.81 472.235 173.81 472.235",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.716 444.873C181.846 442.611 186.743 440.537 190.5 439.06L191.266 424.594H161.997L161.006 455.62C165.062 452.779 172.295 447.845 177.716 444.873Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.47 252.532C205.994 251.99 205.003 262.251 203.826 275.166C202.648 288.1 191.285 424.596 191.285 424.596H161.997L173.192 220.459L205.844 219.095L227.152 220.702",
    fill: "#B7C2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.47 252.532C205.994 251.99 205.003 262.251 203.826 275.166C202.648 288.1 191.285 424.596 191.285 424.596H161.997L173.192 220.459L205.844 219.095L227.152 220.702",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.407 399.307L146.016 419.586L148.11 439.155L152.726 446.836L181.977 430.127L182.93 402.372L178.407 399.307Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.51 424.202C167.922 424.202 169.847 420.595 170.314 416.445C170.781 412.296 175.472 401.119 175.472 401.119L160.165 410.689C160.165 410.689 158.688 415.698 158.95 417.174C159.212 418.651 159.754 419.174 161.361 418.034C162.969 416.894 162.969 416.296 163.641 416.557C164.314 416.819 163.567 420.632 163.511 421.641C163.436 422.669 163.436 424.202 165.51 424.202Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M160.633 432.631C158.894 432.631 154.614 440.387 154.876 443.453C155.138 446.518 155.717 445.097 155.717 445.097L168.221 437.958C168.221 437.958 169.305 435.958 169.155 433.752C169.025 431.547 166.09 433.752 165.548 434.556C165.006 435.36 164.016 436.425 163.212 436.425C162.408 436.425 162.969 432.631 160.633 432.631Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M211.713 252.458C207.676 251.673 206.33 257.766 205.209 262.756C204.087 267.765 203.003 284.53 203.003 284.53C203.003 284.53 231.375 363.665 231.114 366.207C230.852 368.749 216.853 377.16 208.442 382.244C200.031 387.346 179.659 398.28 178.388 399.308C177.117 400.336 177.36 412.298 178.388 421.718C179.416 431.138 181.958 430.128 181.958 430.128C181.958 430.128 206.143 418.167 235.188 403.139C264.214 388.112 265.504 383.533 268.046 378.431C270.588 373.328 264.981 360.6 261.934 350.919C258.887 341.237 233.917 259.747 230.347 248.794C226.777 237.842 227.151 220.74 227.151 220.74L204.685 219.17",
    fill: "#B7C2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.713 252.458C207.676 251.673 206.33 257.766 205.209 262.756C204.087 267.765 203.003 284.53 203.003 284.53C203.003 284.53 231.375 363.665 231.114 366.207C230.852 368.749 216.853 377.16 208.442 382.244C200.031 387.346 179.659 398.28 178.388 399.308C177.117 400.336 177.36 412.298 178.388 421.718C179.416 431.138 181.958 430.128 181.958 430.128C181.958 430.128 206.143 418.167 235.188 403.139C264.214 388.112 265.504 383.533 268.046 378.431C270.588 373.328 264.981 360.6 261.934 350.919C258.887 341.237 233.917 259.747 230.347 248.794C226.777 237.842 227.151 220.74 227.151 220.74L204.685 219.17",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.632 237.076C174.632 237.076 176.389 237.898 179.174 237.898C181.958 237.898 185.566 231.002 185.155 226.759",
    fill: "#B7C2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.632 237.076C174.632 237.076 176.389 237.898 179.174 237.898C181.958 237.898 185.566 231.002 185.155 226.759",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.881 222.552C209.881 222.552 208.741 232.85 208.741 234.102L209.881 222.552Z",
    fill: "#B7C2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.881 222.552C209.881 222.552 208.741 232.85 208.741 234.102",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.012 226.086C214.965 226.086 215.189 224.946 215.189 224.591C215.189 224.236 214.647 223.133 214.012 223.133C213.376 223.133 212.928 224.049 212.928 224.852C212.928 225.656 213.526 226.086 214.012 226.086Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.614 467.75C160.614 467.75 161.586 466.834 163.343 466.909C165.1 466.983 168.371 474.516 173.38 474.273C178.407 474.03 182.65 467.226 189.024 466.909C189.024 466.909 189.024 467.17 188.949 468.329C188.874 469.507 189.36 477.955 193.042 479.543C196.724 481.132 206.518 482.141 209.938 482.889C213.377 483.637 219.9 485.188 217.975 499.953C217.975 499.953 208.779 500.832 198.817 500.252C188.855 499.673 170.034 500.065 167.361 500.122C164.689 500.178 158.072 499.075 158.072 499.075C158.072 499.075 157.661 491.804 158.072 488.533C158.483 485.263 160.502 471.338 160.502 471.338L160.614 467.75Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.428 494.553C158.428 494.553 183.08 494.964 185.828 495.076C188.575 495.188 199.883 496.478 205.901 496.067C211.92 495.655 218.312 495.712 218.312 495.712",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.428 494.553C158.428 494.553 183.08 494.964 185.828 495.076C188.575 495.188 199.883 496.478 205.901 496.067C211.92 495.655 218.312 495.712 218.312 495.712",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.519 483.675C196.519 483.675 193.64 484.217 189.958 484.16C186.276 484.104 184.463 484.104 184.389 482.852C184.333 481.6 190.108 479.936 191.248 479.974C192.388 480.03 191.584 480.834 187.323 480.908C183.08 480.964 182.576 480.217 182.389 479.413C182.202 478.609 189.267 477.731 189.454 477.918C189.641 478.105 188.145 478.553 185.211 478.011C182.277 477.469 180.968 476.666 180.968 475.974C180.968 475.283 187.79 475.413 188.501 475.6",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.519 483.675C196.519 483.675 193.64 484.217 189.958 484.16C186.276 484.104 184.463 484.104 184.389 482.852C184.333 481.6 190.108 479.936 191.248 479.974C192.388 480.03 191.584 480.834 187.323 480.908C183.08 480.964 182.576 480.217 182.389 479.413C182.202 478.609 189.267 477.731 189.454 477.918C189.641 478.105 188.145 478.553 185.211 478.011C182.277 477.469 180.968 476.666 180.968 475.974C180.968 475.283 187.79 475.413 188.501 475.6",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M291.596 119.417C291.596 119.417 280.98 119.155 277.971 120.202C274.962 121.249 273.597 121.791 272.775 121.716C271.953 121.641 271.953 120.781 273.093 119.38C274.233 117.978 277.261 117.099 277.261 116.127C277.261 115.155 276.644 113.903 275.747 113.903C274.85 113.903 272.196 116.127 270.42 118.071C268.644 120.015 267.579 123.305 269.093 125.697C270.607 128.089 273.261 127.996 274.139 127.566C275.018 127.136 276.363 126.145 276.625 126.949C276.887 127.753 274.532 147.565 274.532 147.565L283.97 149.994L291.577 146.368L293.465 133.509C293.465 133.509 299.222 132.276 301.184 130.669C303.128 129.08 304.904 125.697 305.521 122.52C306.137 119.323 305.352 113.38 302.418 113.567C299.484 113.754 296.044 114.726 292.942 115.38C289.839 116.053 287.895 116.426 287.97 117.903C288.045 119.38 294.624 119.249 296.306 119.062C296.306 119.062 290.363 120.557 289.578 120.744C288.774 120.912 287.709 121.716 287.634 122.688C287.54 123.66 289.578 123.566 290.12 123.566C290.643 123.566 294.998 123.398 294.998 123.398C294.998 123.398 289.148 124.276 288.344 124.463C287.54 124.632 286.755 125.043 286.793 126.127C286.83 127.211 288.045 127.379 288.774 127.304C289.503 127.211 294.101 127.043 294.101 127.043C294.101 127.043 288.419 128.276 287.54 128.37C286.662 128.463 286.475 129.697 286.568 130.052C286.662 130.407 287.017 131.211 288.437 131.248C289.858 131.285 295.091 131.416 295.091 131.416",
    fill: "#FAE900"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M291.596 119.417C291.596 119.417 280.98 119.155 277.971 120.202C274.962 121.249 273.597 121.791 272.775 121.716C271.953 121.641 271.953 120.781 273.093 119.38C274.233 117.978 277.261 117.099 277.261 116.127C277.261 115.155 276.644 113.903 275.747 113.903C274.85 113.903 272.196 116.127 270.42 118.071C268.644 120.015 267.579 123.305 269.093 125.697C270.607 128.089 273.261 127.996 274.139 127.566C275.018 127.136 276.363 126.145 276.625 126.949C276.887 127.753 274.532 147.565 274.532 147.565L283.97 149.994L291.577 146.368L293.465 133.509C293.465 133.509 299.222 132.276 301.184 130.669C303.128 129.08 304.904 125.697 305.521 122.52C306.137 119.323 305.352 113.38 302.418 113.567C299.484 113.754 296.044 114.726 292.942 115.38C289.839 116.053 287.895 116.426 287.97 117.903C288.045 119.38 294.624 119.249 296.306 119.062C296.306 119.062 290.363 120.557 289.578 120.744C288.774 120.912 287.709 121.716 287.634 122.688C287.54 123.66 289.578 123.566 290.12 123.566C290.643 123.566 294.998 123.398 294.998 123.398C294.998 123.398 289.148 124.276 288.344 124.463C287.54 124.632 286.755 125.043 286.793 126.127C286.83 127.211 288.045 127.379 288.774 127.304C289.503 127.211 294.101 127.043 294.101 127.043C294.101 127.043 288.419 128.276 287.54 128.37C286.662 128.463 286.475 129.697 286.568 130.052C286.662 130.407 287.017 131.211 288.437 131.248C289.858 131.285 295.091 131.416 295.091 131.416",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.483 86.4456C307.483 86.4456 304.997 86.0905 301.11 85.997C297.204 85.9036 287.989 86.9689 287.989 86.9689L282.046 131.77L301.465 129.527L307.483 86.4456Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.411 86.9697H287.99L282.046 131.771C282.046 131.771 279.747 131.733 279.392 131.21C279.037 130.687 282.644 101.212 283.691 95.8477C284.738 90.4835 285.411 86.9697 285.411 86.9697Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M296.905 96.5763C297.174 96.5763 297.391 96.2416 297.391 95.8287C297.391 95.4158 297.174 95.0811 296.905 95.0811C296.637 95.0811 296.419 95.4158 296.419 95.8287C296.419 96.2416 296.637 96.5763 296.905 96.5763Z",
    fill: "#040222"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.046 64.521C282.962 63.979 284.775 64.9883 285.635 67.1751C286.494 69.3619 286.027 71.5486 285.952 71.9411C285.878 72.3336 283.093 70.8384 282.289 68.4834C281.485 66.1658 281.13 65.0631 282.046 64.521Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M296.419 62.5598C298.157 62.4477 298.082 65.3073 298.082 66.4661C298.082 67.6249 297.092 70.4659 296.419 70.5406C295.727 70.6154 294.755 67.2511 294.774 65.4569C294.793 63.6626 295.223 62.6346 296.419 62.5598Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.645 72.4267C305.86 72.5201 305.786 69.1371 306.645 67.5671C307.505 65.9972 309 63.8291 309.935 64.3711C310.869 64.9131 310.552 67.6606 309.935 68.7446C309.299 69.8474 307.898 72.2584 306.645 72.4267Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.484 133.509C293.484 133.509 299.24 132.276 301.203 130.669C303.147 129.08 304.922 125.697 305.539 122.52C306.156 119.323 305.371 113.38 302.436 113.567C299.502 113.754 296.063 114.726 292.96 115.38C289.858 116.053 287.914 116.426 287.989 117.903C288.064 119.38 294.643 119.249 296.325 119.062C296.325 119.062 290.381 120.557 289.596 120.744C288.792 120.912 287.727 121.716 287.652 122.688C287.559 123.66 289.596 123.566 290.138 123.566C290.661 123.566 295.016 123.398 295.016 123.398C295.016 123.398 289.166 124.276 288.363 124.463C287.559 124.632 286.774 125.043 286.811 126.127C286.849 127.211 288.064 127.379 288.792 127.304C289.521 127.211 294.119 127.043 294.119 127.043C294.119 127.043 288.437 128.276 287.559 128.37C286.68 128.463 286.494 129.697 286.587 130.052C286.68 130.407 287.036 131.211 288.456 131.248C289.876 131.285 295.11 131.416 295.11 131.416",
    fill: "#FAE900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.484 133.509C293.484 133.509 299.24 132.276 301.203 130.669C303.147 129.08 304.922 125.697 305.539 122.52C306.156 119.323 305.371 113.38 302.436 113.567C299.502 113.754 296.063 114.726 292.96 115.38C289.858 116.053 287.914 116.426 287.989 117.903C288.064 119.38 294.643 119.249 296.325 119.062C296.325 119.062 290.381 120.557 289.596 120.744C288.792 120.912 287.727 121.716 287.652 122.688C287.559 123.66 289.596 123.566 290.138 123.566C290.661 123.566 295.016 123.398 295.016 123.398C295.016 123.398 289.166 124.276 288.363 124.463C287.559 124.632 286.774 125.043 286.811 126.127C286.849 127.211 288.064 127.379 288.792 127.304C289.521 127.211 294.119 127.043 294.119 127.043C294.119 127.043 288.437 128.276 287.559 128.37C286.68 128.463 286.494 129.697 286.587 130.052C286.68 130.407 287.036 131.211 288.456 131.248C289.876 131.285 295.11 131.416 295.11 131.416",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M292.232 142.014C292.232 142.014 285.317 137.042 284.532 135.996C283.728 134.93 283.373 133.248 284.625 133.248C285.859 133.248 290.139 134.407 293.484 133.51",
    fill: "#040222"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M292.232 142.014C292.232 142.014 285.317 137.042 284.532 135.996C283.728 134.93 283.373 133.248 284.625 133.248C285.859 133.248 290.139 134.407 293.484 133.51",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.459 138.256L189.34 137.098L184.855 167.432C184.855 167.432 183.004 177.861 181.191 183.543C179.378 189.225 173.192 220.476 173.192 220.476C173.192 220.476 188.948 221.634 201.34 221.634C213.731 221.634 227.17 220.737 227.17 220.737C227.17 220.737 228.459 209.635 229.244 201.636C230.011 193.636 231.599 157.096 231.599 157.096L232.459 138.256Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.902 216.961C173.902 216.961 197.826 214.999 204.312 213.784C210.797 212.588 226.796 206.999 226.796 206.999L176.257 205.485L173.902 216.961Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.472 175.244C183.472 175.244 184.164 177.562 186.014 173.973C187.864 170.385 191.191 166.665 193.658 150.012C196.126 133.359 188.126 150.928 188.126 150.928L185.397 163.806L183.472 175.244Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.602 150.107C192.444 151.658 175.23 187.188 174.501 188.628C173.772 190.086 172.65 192.328 173.865 192.328C175.08 192.328 183.734 193.151 190.556 193.375C197.378 193.599 208.181 192.964 208.181 192.964L204.312 208.402C204.312 208.402 171.716 209.486 164.707 209.486C157.698 209.486 152.315 209.841 149.811 205C147.306 200.16 153.586 189.039 159.978 174.797C166.37 160.555 185.154 123.903 195.696 116.539C201.882 112.203 212.218 112.52 217.638 112.371C225.75 112.147 230.908 111.791 233.357 115.455C235.805 119.118 270.794 175.544 270.794 175.544L274.532 147.565C274.532 147.565 280.849 147.341 284.213 147.172C287.578 147.004 291.577 146.35 291.577 146.35C291.577 146.35 289.503 183.525 287.708 189.861C285.895 196.179 280.475 204.328 272.476 204.328C264.476 204.328 258.14 196.197 252.851 189.095C247.58 181.993 231.581 157.078 231.581 157.078",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.602 150.107C192.444 151.658 175.23 187.188 174.501 188.628C173.772 190.086 172.65 192.328 173.865 192.328C175.08 192.328 183.734 193.151 190.556 193.375C197.378 193.599 208.181 192.964 208.181 192.964L204.312 208.402C204.312 208.402 171.716 209.486 164.707 209.486C157.698 209.486 152.315 209.841 149.811 205C147.306 200.16 153.586 189.039 159.978 174.797C166.37 160.555 185.154 123.903 195.696 116.539C201.882 112.203 212.218 112.52 217.638 112.371C225.75 112.147 230.908 111.791 233.357 115.455C235.805 119.118 270.794 175.544 270.794 175.544L274.532 147.565C274.532 147.565 280.849 147.341 284.213 147.172C287.578 147.004 291.577 146.35 291.577 146.35C291.577 146.35 289.503 183.525 287.708 189.861C285.895 196.179 280.475 204.328 272.476 204.328C264.476 204.328 258.14 196.197 252.851 189.095C247.58 181.993 231.581 157.078 231.581 157.078",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M205.358 116.557C205.358 116.557 204.89 129.285 206.554 130.855C208.217 132.425 212.404 129.229 212.404 129.229",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M205.358 116.557C205.358 116.557 204.89 129.285 206.554 130.855C208.217 132.425 212.404 129.229 212.404 129.229",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M221.319 127.658C221.319 127.658 223.356 131.453 224.553 131.434C225.749 131.415 229.505 120.986 230.758 119.416",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.319 127.658C221.319 127.658 223.356 131.453 224.553 131.434C225.749 131.415 229.505 120.986 230.758 119.416",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M204.311 155.749C204.311 155.749 208.18 151.506 208.18 148.647C208.18 145.787 206.255 143.694 206.255 142.498C206.255 141.899 206.498 141.899 206.498 141.899",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M204.311 155.749C204.311 155.749 208.18 151.506 208.18 148.647C208.18 145.787 206.255 143.694 206.255 142.498C206.255 141.899 206.498 141.899 206.498 141.899",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M223.432 153.862C223.432 153.862 227.806 150.498 227.806 147.825C227.806 145.152 224.573 142.33 224.33 141.807C224.18 141.47 224.33 141.283 224.33 141.283",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M223.432 153.862C223.432 153.862 227.806 150.498 227.806 147.825C227.806 145.152 224.573 142.33 224.33 141.807C224.18 141.47 224.33 141.283 224.33 141.283",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M196.536 193.41C196.536 193.41 194.817 197.298 194.125 200.718C193.433 204.157 193.602 208.736 193.602 208.736",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.536 193.41C196.536 193.41 194.817 197.298 194.125 200.718C193.433 204.157 193.602 208.736 193.602 208.736",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M272.774 160.871C272.774 160.871 276.139 161.824 281.559 161.824C286.998 161.824 288.773 161.357 288.773 161.357",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M272.774 160.871C272.774 160.871 276.139 161.824 281.559 161.824C286.998 161.824 288.773 161.357 288.773 161.357",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M266.308 168.274C266.308 168.274 264.122 177.825 265.523 181.825C266.925 185.825 269.168 184.161 269.71 183.507C270.271 182.853 270.813 175.545 270.813 175.545L266.308 168.274Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M216.498 130.651L215.656 131.754L211.395 155.752C211.395 155.752 207.227 177.956 207.283 178.218C207.339 178.48 211.152 187.395 211.526 187.339C211.9 187.283 214.946 178.723 215.002 178.218C215.058 177.713 217.862 130.184 217.862 130.184L216.498 130.651Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M216.235 129.025C216.235 129.025 215.375 129.548 215.506 130.95C215.637 132.352 216.123 132.651 216.515 132.595C216.908 132.539 217.898 131.454 217.861 130.165C217.823 128.894 217.524 128.109 216.87 127.903",
    fill: "#5D21D2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M216.235 129.025C216.235 129.025 215.375 129.548 215.506 130.95C215.637 132.352 216.123 132.651 216.515 132.595C216.908 132.539 217.898 131.454 217.861 130.165C217.823 128.894 217.524 128.109 216.87 127.903",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M204.312 208.423C204.312 208.423 224.142 208.31 227.17 208.423C230.198 208.535 232.908 208.703 233.319 206.142C233.712 203.582 233.319 202.872 233.319 202.872C233.319 202.872 235.319 201.918 235.543 199.208C235.786 196.498 234.422 195.863 234.422 195.863C234.422 195.863 237.207 194.909 237.3 192.125C237.375 189.34 235.637 189.396 232.833 189.489C230.03 189.564 226.142 189.471 226.142 189.471H233.469C233.469 189.471 232.908 186.274 227.077 186.405C221.245 186.536 219.021 190.648 218.759 192.33C218.759 192.33 220.255 192.33 220.815 191.863C220.815 191.863 220.217 192.293 218.759 192.33C217.302 192.368 208.181 193.022 208.181 193.022L204.312 208.423Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M257.748 178.309C257.748 177.487 256.402 177.936 255.486 178.01C254.571 178.085 242.328 178.609 240.441 178.833C238.553 179.057 238.403 184.776 238.403 184.776C238.403 184.776 235.394 185.3 232.422 185.524C231.432 185.599 230.628 186.066 229.993 186.645C228.946 187.972 229.264 189.468 229.264 189.468C229.264 189.468 234.497 189.393 235.151 189.468C235.824 188.309 236.684 187.916 237.731 187.767C239.394 187.543 239.843 188.44 239.768 189.879C239.693 191.299 238.198 197.99 237.955 201.074C237.712 204.158 235.619 204.233 234.871 204.383C234.385 204.476 233.88 204.214 233.45 203.803C233.469 204.308 233.45 205.055 233.282 206.121C233.002 207.915 231.563 208.364 229.675 208.438C230.909 209.56 232.759 210.233 234.628 210.326C238.086 210.476 239.058 207.766 239.058 207.766C239.058 207.766 239.955 211.448 245.749 211.522C251.543 211.597 254.926 207.691 256.421 201.149C257.991 194.626 257.748 179.132 257.748 178.309Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M248.646 172.237C248.646 172.237 252.309 171.246 252.533 166.368C252.757 161.49 250.421 161.808 250.589 160.873C250.758 159.939 251.972 157.509 251.748 155.285C251.524 153.06 250.533 151.191 248.646 151.191C246.758 151.191 244.758 153.659 244.758 155.752C244.758 157.845 246.87 161.826 246.87 163.172C246.87 164.518 244.646 164.387 244.646 167.602C244.646 170.798 246.646 172.349 248.646 172.237Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M231.581 110.221C231.581 110.221 231.806 113.717 234.179 113.548C236.572 113.38 238.217 110.801 237.618 105.848C237.002 100.895 235.749 89.9797 235.749 89.9797L231.824 88.4658L231.581 110.221Z",
    fill: "#040222"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M205.396 68.916C208.61 68.916 211.414 69.5141 211.414 74.5979C211.414 74.5979 212.423 73.925 213.283 73.925C214.124 73.925 216.759 76.1305 216.759 80.6162C216.759 85.1019 214.292 86.0364 213.881 86.0364C213.451 86.0364 212.517 85.8682 212.274 85.4383C212.274 85.4383 208.984 86.8588 208.367 82.0554C208.068 79.7004 208.536 78.3173 208.536 78.3173C208.536 78.3173 205.994 79.0088 204.125 79.0088C202.256 79.0088 199.882 77.065 199.882 73.7568C199.882 70.4486 203.153 68.916 205.396 68.916Z",
    fill: "#040222"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M210.312 111.996C210.312 111.996 208.2 126.5 217.171 126.5C224.554 126.5 226.162 115.473 226.162 115.473C226.162 115.473 232.61 116.407 233.451 108.856C234.292 101.305 233.955 96.6515 234.46 94.7077C234.965 92.7639 235.731 88.7642 235.731 88.7642L225.9 85.1943L215.209 89.5118L210.723 96.8945L210.312 111.996Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M218.965 108.689C218.965 108.689 218.703 115.474 226.18 115.474",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M227.301 104.241C227.301 104.241 227.824 108.129 229.843 108.129C231.207 108.129 232.459 104.895 232.459 104.895",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M231.955 95.5312C231.955 95.5312 232.31 97.6993 232.721 98.746C233.132 99.7927 233.263 100.596 233.039 100.877C232.815 101.157 232.048 101.363 231.319 101.419C230.59 101.475 230.329 102.409 230.59 103.138",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M216.199 96.391L223.377 95.6621",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M230.235 95.3436C230.235 95.3436 230.758 94.0539 232.515 94.9324",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M226.945 92.9893C229.282 92.9893 230.235 94.391 230.235 96.5591C230.235 98.7272 228.086 99.344 226.572 99.344C225.058 99.344 223.376 99.0823 223.376 96.1666C223.376 93.2509 226.945 92.9893 226.945 92.9893Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M235.468 92.6729C237.767 92.6729 238.141 94.9905 238.141 96.168C238.141 97.3641 236.609 99.0089 234.665 99.0089C232.721 99.0089 232.216 97.8314 232.216 96.3175C232.216 94.8036 233.487 92.6729 235.468 92.6729Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M209.564 113.326C205.359 113.662 201.228 112.653 201.228 107.569C201.228 102.485 207.396 98.7096 207.994 98.4106C208.611 98.1116 212.424 90.1681 214.069 87.6823C215.714 85.2152 218.087 81.3836 223.358 81.3836C228.629 81.3836 228.442 80.636 233.133 81.8696C237.824 83.1032 237.469 87.7384 237.469 88.8224C237.469 89.9065 236.535 92.1119 235.712 92.1119C234.89 92.1119 235.077 91.084 235.077 91.084C235.077 91.084 234.292 91.6634 233.488 90.2429C233.488 90.2429 232.909 91.2148 231.806 91.2148C230.703 91.2148 230.479 89.9999 230.479 89.9999C230.479 89.9999 229.974 91.383 228.816 91.383C227.657 91.383 227.339 90.3177 227.339 90.3177C227.339 90.3177 226.741 92.0372 225.713 92.0372C224.685 92.0372 224.442 90.2616 224.573 89.0654C224.573 89.0654 220.966 90.2616 220.181 94.3174C220.181 94.3174 217.19 95.2332 216.555 95.3454C215.919 95.4575 215.938 93.8128 214.686 93.8128C213.433 93.8128 212.48 95.9248 212.48 97.663C212.48 99.4012 212.966 100.672 214.368 100.111C215.77 99.532 216.555 99.233 216.742 97.7938C216.947 96.336 217.041 96.336 217.358 96.2986C217.676 96.2612 220.33 95.9995 220.33 95.9995C220.33 95.9995 218.629 103.793 217.826 106.971C217.022 110.148 216.349 112.036 215.078 112.466C213.807 112.858 211.49 113.176 209.564 113.326Z",
    fill: "#040222"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.123 95.1387C226.123 95.1387 225.917 96.9703 226.945 96.9703C227.973 96.9703 228.385 96.0545 228.385 96.0545",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M233.749 95.1387C233.749 95.1387 233.842 96.4096 234.515 96.4096C235.188 96.4096 235.487 95.5499 235.487 95.5499",
    stroke: "#040222",
    strokeWidth: 0.656569,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M218.872 108.353C218.872 108.353 218.536 108.054 218.311 108.746C217.47 111.363 218.517 117.829 221.208 118.428C223.881 119.007 226.572 116.801 226.572 116.801L226.049 115.474C218.704 115.4 218.872 108.353 218.872 108.353Z",
    fill: "#040222"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.436 444.125C157.436 444.125 157.773 440.051 154.165 437.939C150.558 435.827 149.156 434.089 149.848 431.509C150.558 428.949 153.287 423.884 153.287 419.959C153.287 416.034 150.689 416.651 150.689 416.651L120.56 433.808C120.56 433.808 120.56 487.655 120.56 489.879C120.56 492.104 121.476 495.337 125.401 494.926C129.345 494.515 134.802 491.786 136.017 486.852C137.232 481.899 138.559 463.208 139.008 459.881C139.456 456.555 141.549 452.798 152.726 446.854L157.436 444.125Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M145.774 441.323C147.232 440.874 147.792 442.108 147.942 443.566C148.091 445.042 148.746 449.08 148.746 449.08L144.914 451.64C144.914 451.64 143.68 447.21 143.83 444.818C143.979 442.426 144.521 441.715 145.774 441.323Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M139.008 454.181C139.008 454.181 137.83 448.593 137.942 446.817C138.055 445.042 138.54 444.331 139.494 444.219C140.447 444.107 140.933 445.771 140.989 447.135C141.045 448.499 141.811 454.349 141.811 454.349",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M139.008 454.181C139.008 454.181 137.83 448.593 137.942 446.817C138.055 445.042 138.54 444.331 139.494 444.219C140.447 444.107 140.933 445.771 140.989 447.135C141.045 448.499 141.811 454.349 141.811 454.349",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M143.81 445.694C143.754 443.115 142.951 442.629 142.334 442.797C141.717 442.966 140.727 445.545 141.156 449.115",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M143.81 445.694C143.754 443.115 142.951 442.629 142.334 442.797C141.717 442.966 140.727 445.545 141.156 449.115",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M125.775 430.837L124.635 494.945",
    stroke: "#040222",
    strokeWidth: 1.31314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1656_20388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H424C428.418 0 432 3.58172 432 8V552C432 556.418 428.418 560 424 560H0V0Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadApp1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downloadApp_1.ded42f040d2ab81282fa230fca6dd0e7.svg";